var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wm-wrap"},[_vm._t("default"),(_vm.showWatermark)?_c('div',{staticClass:"wm-layer",style:(_vm.watermarkStyle)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }